<template>
  <div>
    <div>
      <ejs-schedule
        id="Schedule"
        ref="ScheduleObj"
        width="100%"
        height="800px"
        showTimeIndicator="true"
        showWorkHours="false"
        :workHours="{ highlight: false }"
        :allowDragAndDrop="true"
        :allowResizing="false"
        :eventSettings="eventSettings"
        :selectedDate="selectedDate"
        :onActionBegin="onActionBegin"
        @dragStop="dragStop"
        :cellTemplate="cellTemplate"
        @actionComplete="actionComplete"
        @popupOpen="popupOpen"
        currentView="Day"
        :group="group"
      >
        <e-views>
          <e-view option="Day"></e-view>
          <e-view option="Week"></e-view>
          <e-view option="Month"></e-view>
          <e-view option="Agenda"></e-view>
          <e-view option="TimelineDay"></e-view>
          <e-view option="TimelineWeek"></e-view>
          <e-view option="TimelineMonth"></e-view>
        </e-views>
        <e-resources>
          <e-resource
            field="ProviderId"
            title="ProviderName"
            name="Providers"
            :dataSource="providerDataSource"
            textField="ProviderName"
            idField="ProviderId"
          >
          </e-resource>
        </e-resources>
      </ejs-schedule>
    </div>
  </div>
</template>

<script>
import "/node_modules/@syncfusion/ej2-base/styles/bootstrap.css";
import "/node_modules/@syncfusion/ej2-buttons/styles/bootstrap.css";
import "/node_modules/@syncfusion/ej2-calendars/styles/bootstrap.css";
import "/node_modules/@syncfusion/ej2-dropdowns/styles/bootstrap.css";
import "/node_modules/@syncfusion/ej2-inputs/styles/bootstrap.css";
import "/node_modules/@syncfusion/ej2-navigations/styles/bootstrap.css";
import "/node_modules/@syncfusion/ej2-popups/styles/bootstrap.css";
import "/node_modules/@syncfusion/ej2-vue-schedule/styles/bootstrap.css";
import Vue from "vue";
import ApptCell from "./ApptCell.vue";
import Cell from "./Cell.vue";

import {
  SchedulePlugin,
  Day,
  Week,
  Month,
  Agenda,
  TimelineViews,
  DragAndDrop,
} from "@syncfusion/ej2-vue-schedule";

export default {
  components: { ApptCell, Cell },

  mounted() {
    var self = this;

    this.scheduledObject = self.$refs.ScheduleObj;

    this.$emitter.on("appts-refresh", () => {
      self.bind(self.$data.startDate, self.$data.endDate, false);
    });

    this.bind(this.startDate, this.endDate);
  },
  beforeDestroy() {
    this.$emitter.off("appts-refresh", null);
  },
  methods: {
    actionComplete(e) {
      // this gets called a bunch of times
      if (e.requestType != "dateNavigate") return;

      var l = this.scheduledObject.getCurrentViewDates();
      this.startDate = l[0];
      this.endDate = l[l.length - 1];

      this.bind(this.startDate, this.endDate, true);

      //this. (e.currentDate, e.currentDate);
    },
    async dragStop(e) {
      let provider = this.providerDataSource[e.target.dataset.groupIndex];

      let r = await this.$client.post("/api/appt/move", {
        id: e.data.Id,
        providerId: provider.ProviderId,
        startDate: e.data.StartTime,
        endDate: e.data.EndTime,
      });

      console.log(r.data.value.textMessage);
    },
    async bind(startDate, endDate, scroll = true) {
      console.log("provider appts..");
      let r = await this.$client.post("/api/appt/GetProviderAppts", {
        startDate: this.$moment(startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(endDate).format("YYYY-MM-DD"),
      });

      this.providerSchedules = [[]];

      r.data.value.providers.forEach((a) => {
        a.ProviderId = a.providerId;
        delete a.providerId;

        a.ProviderName = a.providerName;
        delete a.providerName;

        var z = [];
        this.providerSchedules.push(z);

        a.schedules.forEach((s) => {
          z.push(s);
        });
      });

      this.providerDataSource = r.data.value.providers;

      r.data.value.appts.forEach((a) => {
        a.Status = a.status;

        delete a.status;
        a.StartTime = a.startTime;
        delete a.startTime;

        a.EndTime = a.endTime;
        delete a.endTime;

        a.ProviderId = a.providerId;
        delete a.providerId;

        a.Subject = a.subject;
        delete a.subject;

        a.Id = a.id;
        delete a.id;
      });

      this.scheduledObject.ej2Instances.eventSettings.dataSource = [];

      this.scheduledObject.ej2Instances.eventSettings.dataSource.push(
        ...r.data.value.appts
      );

      var self = this;

      if (r.data.value.firstTime && scroll) {
        setTimeout(() => {
          self.$refs.ScheduleObj.scrollTo(
            self.$moment(r.data.value.firstTime).format("HH:mm")
          );
        }, 300);
      }
    },
    popupOpen(e) {
      e.cancel = true;
    },

    cellClick(e) {
      e.cancel = true;
    },
    cellDoubleClick(e) {
      e.cancel = true;
      console.log(e);
    },
    onActionBegin(e) {
      e.cancel = true;
    },
  },
  data() {
    let a = this;
    return {
      scheduleObject: null,
      selectedDate: new Date(),
      providerSchedules: [[]],
      startDate: new Date(),
      endDate: new Date(),
      group: {
        resources: ["Providers"],
      },
      providerDataSource: [],
      cellTemplate: function(e) {
        return {
          template: {
            extends: Cell,
            propsData: {
              providersSchedules: a.providerSchedules,
            },
          },
        };
      },
      eventSettings: {
        dataSource: [],

        template: function(e) {
          return {
            template: ApptCell,
          };
        },
      },
    };
  },
  provide: {
    schedule: [Day, Week, Month, Agenda, TimelineViews, DragAndDrop],
  },
};
</script>
<style scoped>
#container {
  height: -moz-calc(100% - 180px);
  height: -webkit-calc(100% - 180px);
  height: calc(100% - 180px);
}
</style>
